module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dFuW0"))).then(() => parcelRequire('5erN3'));